var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CrewSection',{attrs:{"crew":_vm.crew,"kicker":"The People Across the Years","trip-label":"re:Invent"}})
}
var staticRenderFns = []

export { render, staticRenderFns }